export const T = {
  moss:       "#4a6840",
  mossDeep:   "#3a5432",
  mossDark:   "#2a3d22",
  lime:       "#d4e8a0",
  headerText: "#f0f7eb",
  linen:      "#f5ede2",
  linen2:     "#eddecf",
  linen3:     "#dccab8",
  cream:      "#fdf0e8",
  blush:      "#f2c4b0",
  bark:       "#3d2010",
  muted:      "#7a6555",
};

export const TYPE_ICONS = {
  tea:      "🫖",
  bath:     "🛁",
  tincture: "🌿",
  juice:    "🥤",
};

export const TYPE_COLORS = {
  tea:      { bg: "#d4e8c8", text: "#2a5020" },
  bath:     { bg: "#c8dce8", text: "#1a3a4a" },
  tincture: { bg: "#ecddc8", text: "#5a3a10" },
  juice:    { bg: "#f2e4c0", text: "#6a4410" },
};

export const ALL_TYPES = ["tea", "bath", "tincture", "juice"];
